import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { PageContext, Redirector4SaleConfig } from 'src/app/service/redirector.service'
import { PriceComponent } from 'src/app/elements/price/price.component'
import { TaxNoteComponent } from 'src/app/elements/tax-note/tax-note.component'

import { SafePipe } from 'src/app/pipes/safe.pipe'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { ContactformComponent } from 'src/app/elements/contactform/contactform.component'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { ContentBlockComponent } from 'src/app/elements/content-block/content-block.component'
import { RouterLink } from '@angular/router'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  selector: 'app-forsale-smart',
  templateUrl: './forsale-smart.component.html',
  styleUrl: './forsale-smart.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PriceComponent,
    TaxNoteComponent,
    SafePipe,
    IconComponent,
    ContactformComponent,
    I18nSelectorComponent,
    ContentBlockComponent,
    RouterLink,
    UserTokenPipe
],
})
export class ForsaleSmartComponent {
  @Input() context!: PageContext<Redirector4SaleConfig>
  protected readonly year = new Date().getFullYear()

  constructor () {
  }
}
